module.exports = __webpack_public_path__ + "img/NG_Wenze_2024.94c74a95.jpg";